export const GET_ENLIGHTEN_NOTICES_REQUEST = 'GET_MOST_USED_VALUES_REQUEST';
export const GET_ENLIGHTEN_NOTICES_SUCCESS = 'GET_MOST_USED_VALUES_SUCCESS';
export const GET_ENLIGHTEN_NOTICES_FAILURE = 'GET_MOST_USED_VALUES_FAILURE';

export const ENLIGHTEN_NOTICES_DELETE_REQUEST = 'ENLIGHTEN_NOTICES_DELETE_REQUEST';
export const ENLIGHTEN_NOTICES_DELETE_SUCCESS = 'ENLIGHTEN_NOTICES_DELETE_SUCCESS';
export const ENLIGHTEN_NOTICES_DELETE_FAILURE = 'ENLIGHTEN_NOTICES_DELETE_FAILURE';

export const ENLIGHTEN_NOTICES_POPULATE_REQUEST = 'ENLIGHTEN_NOTICES_POPULATE_REQUEST';
export const ENLIGHTEN_NOTICES_CREATE_SUCCESS = 'ENLIGHTEN_NOTICES_CREATE_SUCCESS';
export const ENLIGHTEN_NOTICES_POPULATE_FAILURE = 'ENLIGHTEN_NOTICES_POPULATE_FAILURE';

export const GET_NOTICE_S3_URL_REQUEST = 'GET_NOTICE_S3_URL_REQUEST';
export const GET_NOTICE_S3_URL_SUCCESS = 'GET_NOTICE_S3_URL_SUCCESS';
export const GET_NOTICE_S3_URL_FAILURE = 'GET_NOTICE_S3_URL_FAILURE';

export const GET_USER_EMAILS_REQUEST = 'GET_USER_EMAILS_REQUEST';
export const GET_USER_EMAILS_SUCCESS = 'GET_USER_EMAILS_SUCCESS';
export const GET_USER_EMAILS_FAILURE = 'GET_USER_EMAILS_FAILURE';

export const DELETE_IMAGE_S3_URL_REQUEST = 'DELETE_IMAGE_S3_URL_REQUEST';
export const DELETE_IMAGE_S3_URL_SUCCESS = 'DELETE_IMAGE_S3_URL_SUCCESS';
export const DELETE_IMAGE_S3_URL_FAILURE = 'DELETE_IMAGE_S3_URL_FAILURE';

export const GET_REVENUE_REPORT_FILE_REQUEST = 'GET_REVENUE_REPORT_FILE_REQUEST';
export const GET_REVENUE_REPORT_FILE_SUCCESS = 'GET_REVENUE_REPORT_FILE_SUCCESS';
export const GET_REVENUE_REPORT_FILE_FAILURE = 'GET_REVENUE_REPORT_FILE_FAILURE';

export const GET_SERVICE_ROLES_REQUEST = 'GET_SERVICE_ROLES_REQUEST';
export const GET_SERVICE_ROLES_SUCCESS = 'GET_SERVICE_ROLES_SUCCESS';
export const GET_SERVICE_ROLES_FAILURE = 'GET_SERVICE_ROLES_FAILURE';

export const UPDATE_SERVICE_ROLES_REQUEST = 'UPDATE_SERVICE_ROLES_REQUEST';
export const UPDATE_SERVICE_ROLES_SUCCESS = 'UPDATE_SERVICE_ROLES_SUCCESS';
export const UPDATE_SERVICE_ROLES_FAILURE = 'UPDATE_SERVICE_ROLES_FAILURE';
